import { render } from "./AssociationAdminDashboard.vue?vue&type=template&id=10b55ea6&scoped=true"
import script from "./AssociationAdminDashboard.vue?vue&type=script&lang=js"
export * from "./AssociationAdminDashboard.vue?vue&type=script&lang=js"

import "./AssociationAdminDashboard.vue?vue&type=style&index=0&id=10b55ea6&scoped=true&lang=css"
import "./AssociationAdminDashboard.vue?vue&type=style&index=1&id=10b55ea6&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b55ea6"]])

export default __exports__